import { TransportScope } from "src/tmc-yard/common/model/transport.model";
import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { ComponentSelectionStorageService } from 'src/tmc-common/services/component-selection-storage.service';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { ConfigurationService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';

export interface GcCaseDialogData {
  qrCodeUrl: string;
  carrier: string;
  name: string;
  identifier: string;
  transportScope: TransportScope;
  transportId: number;
}

const GC_CASE_DIALOG_UPDATE_DISPLAY_AUTOMATICALLY = 'gc.case-dialog.update-display-automatically';

@Component({
  selector: 'app-gc-case-dialog',
  templateUrl: './gc-case-dialog.component.html',
  styleUrls: ['./gc-case-dialog.component.scss']
})
export class GcCaseDialogComponent {


  dynamicDisplayEnabled = false;

  updateDisplayAutomatically = false;

  detailsFormGroup = new FormGroup({});

  constructor(
    public dialogRef: MatDialogRef<GcCaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GcCaseDialogData,
    public translationService: TranslationService,
    private componentSelectionStorageService: ComponentSelectionStorageService,
    private configurationService: ConfigurationService,
    private http: HttpService
  ) {

    this.dynamicDisplayEnabled = this.configurationService.getClientParamValue('display.gc-connection.display-key', null) != null &&
      configurationService.getClientParamValue('display.gc-connection.display-key', null).length > 0;

    const stored = this.componentSelectionStorageService.get(GC_CASE_DIALOG_UPDATE_DISPLAY_AUTOMATICALLY);
    if (stored != null) {
      this.updateDisplayAutomatically = stored;
    }

    this.detailsFormGroup.addControl('updateDisplayAutomatically', new FormControl(this.updateDisplayAutomatically, []));

    if (this.dynamicDisplayEnabled) {
      this.detailsFormGroup.valueChanges.subscribe(values => {
        if (this.detailsFormGroup.dirty) {
          this.updateDisplayAutomatically = this.detailsFormGroup.controls.updateDisplayAutomatically.value;
          this.componentSelectionStorageService.save(GC_CASE_DIALOG_UPDATE_DISPLAY_AUTOMATICALLY, this.updateDisplayAutomatically);
          if (this.updateDisplayAutomatically) {
            this.activateGlobalConnectDisplay();
          }
        }
      }
      );
    }

    if (this.updateDisplayAutomatically) {
      this.activateGlobalConnectDisplay();
    }
  }

  public activateGlobalConnectDisplayAction() {
    this.activateGlobalConnectDisplay();
  }

  private activateGlobalConnectDisplay() {
    if (this.dynamicDisplayEnabled) {
      this.performActivation(this.data.transportId).subscribe(response => {
        console.log('Activate GlobalConnect display succeeded', response);
      });
    }
  }

  public performActivation(transportId: number): Observable<any> {
    const url = `${environment.displaysEndpoint}/activate-gc`;
    return this.http.postWithContext<any>(url, transportId);
  }
}
